import React from 'react';
import { Link } from 'react-router-dom';
import { logos } from '../assets';
import Icons from './Icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo">
              <img src={logos.footer} alt="GesOps LLC" className="footer-logo-image" />
            </div>
            <p className="footer-description">
              Directorio nacional de profesionales verificados. Conectamos personas con profesionales de confianza en todo Estados Unidos y Puerto Rico.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61583471817301" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <Icons.Facebook />
              </a>
              <a href="https://www.instagram.com/gesopsllc?igsh=bmF4bnBjYXd0MGtq" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <Icons.Instagram />
              </a>
              <a href="https://wa.me/18049608133" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="WhatsApp">
                <Icons.WhatsApp />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Enlaces Principales</h3>
            <ul className="footer-links">
              <li><Link to="/">Inicio</Link></li>
              <li><Link to="/nosotros">Nosotros</Link></li>
              <li><Link to="/directorio">Directorio</Link></li>
              <li><Link to="/soy-abogado">Soy Abogado</Link></li>
              <li><Link to="/contacto">Contacto</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Servicios</h3>
            <ul className="footer-links">
              <li><Link to="/explora">Directorio de Profesionales</Link></li>
              <li><Link to="/profesionales/planes">Membresías Premium</Link></li>
              <li><Link to="/soporte">Soporte Profesional</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Información Legal</h3>
            <ul className="footer-links">
              <li><Link to="/politica-privacidad"><Icons.Shield /> Política de Privacidad</Link></li>
              <li><Link to="/terminos-condiciones"><Icons.FileText /> Términos y Condiciones</Link></li>
              <li><Link to="/aviso-legal"><Icons.Scale /> Aviso Legal</Link></li>
              <li><Link to="/politica-cookies"><Icons.AlertCircle /> Política de Cookies</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contacto</h3>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon"><Icons.Email /></span>
                <span>gesopsllc@gmail.com</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon"><Icons.MessageSquare /></span>
                <span>WhatsApp Business</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon"><Icons.Globe /></span>
                <span>www.gesops.com</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon"><Icons.Building /></span>
                <span>1420 Celebration Blvd STE 101<br />Kissimmee, FL 34747, EE. UU.</span>
              </div>
            </div>
          </div>
        </div>


        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>
                <strong>GesOps LLC</strong> © 2025 — Todos los derechos reservados.
              </p>
              <p className="address-line">
                1420 Celebration Blvd STE 101, Kissimmee, FL 34747, EE. UU.
              </p>
            </div>
            <div className="footer-tagline">
              <p>
                <strong>Atención 100% virtual.</strong> Directorio nacional de profesionales verificados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
